<!-- Scheduled Orders List Page with Splitter Layout -->
<div class="scheduled-orders-list-page mt-2">
  <!-- Main Content Layout with Flex -->
  <div class="main-layout" *ngIf="!initialLoading()">
    <!-- Sidebar Toggle (always visible) -->
    <div class="sidebar-toggle-area">
      <p-button
        [icon]="sidebarCollapsed() ? 'pi pi-angle-right' : 'pi pi-angle-left'"
        [text]="true"
        size="small"
        (onClick)="toggleSidebar()"
        [pTooltip]="sidebarCollapsed() ? 'Expand filters' : 'Collapse filters'"
        tooltipPosition="right"
        class="sidebar-toggle-btn"
      />

      <!-- Collapsed State with Filter Button -->
      <div class="collapsed-controls" *ngIf="sidebarCollapsed()">
        <button
          class="collapsed-filter-btn"
          (click)="toggleSidebar()"
          [pTooltip]="'Filters'"
          tooltipPosition="right"
        >
          <i class="pi pi-filter"></i>
          <div class="filter-dot-indicator" *ngIf="hasActiveFilters()">
            <i class="pi pi-circle-fill"></i>
          </div>
        </button>
        <!-- Clear All Button for Collapsed State -->
        <button
          *ngIf="hasActiveFilters()"
          class="collapsed-clear-btn"
          (click)="onClearFilters(); $event.stopPropagation()"
          [pTooltip]="'Clear All Filters'"
          tooltipPosition="right"
        >
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <!-- Mobile Backdrop (click to close filter sidebar) -->
    <div
      class="mobile-backdrop"
      [class.visible]="!sidebarCollapsed()"
      (click)="toggleSidebar()"
    ></div>

    <!-- Filter Sidebar -->
    <div class="filter-sidebar" [class.collapsed]="sidebarCollapsed()">
      <!-- Filter Content -->
      <div class="sidebar-content">
        <app-scheduled-orders-filters
          [filterForm]="filterForm"
          [counts]="counts()"
          [loading]="loading() || loadingCounts()"
          [drawerMode]="true"
          [showCreateButton]="!isShopifySite()"
          [skipLocalStorageLoad]="skipLocalStorageLoad()"
          (filtersChanged)="onFiltersChanged($event)"
          (clearFilters)="onClearFilters()"
          (createNew)="onCreateNew()"
        />
      </div>
    </div>

    <!-- Main Content Area -->
    <div class="content-area" [class.sidebar-open]="!sidebarCollapsed()">
      <!-- Compact Toolbar -->
      <div
        class="content-toolbar surface-section border-bottom-1 surface-border"
      >
        <div
          class="flex align-items-center justify-content-between p-2 justify-between"
        >
          <div class="flex align-items-center items-center gap-3">
            <span class="text-sm text-600">
              {{ data()?.TotalRecords || 0 }}
              {{ data()?.TotalRecords === 1 ? "Order" : "Orders" }}
            </span>
            <!-- Mobile-only Select All -->
            <div class="mobile-select-all flex align-items-center gap-2">
              <p-checkbox
                [binary]="true"
                [ngModel]="isAllSelected()"
                [indeterminate]="isSomeSelected()"
                (ngModelChange)="toggleSelectAll()"
                [disabled]="loading() || !data()?.Items?.length"
                inputId="mobileSelectAllWrapper"
              />
              <label
                for="mobileSelectAllWrapper"
                class="text-sm text-600 cursor-pointer"
              >
                Select All
              </label>
            </div>
          </div>
          <div class="flex align-items-center gap-2">
            <!-- Mobile-only Bulk Actions Toolbar -->
            <div class="mobile-bulk-actions">
              <app-bulk-actions-toolbar
                [selectedCount]="selectedItems().length"
                [loading]="bulkOperationLoading()"
                (bulkAction)="onBulkAction($event)"
              />
            </div>
            <!-- Create New button - hidden for Shopify sites (matches old QMC pattern) -->
            <p-button
              *ngIf="!isShopifySite()"
              label="Create"
              icon="pi pi-plus"
              size="small"
              styleClass="create-button"
              (onClick)="onCreateNew()"
            />
          </div>
        </div>
      </div>

      <!-- Responsive Data Table Component -->
      <div class="table-container flex-1 overflow-hidden">
        <app-scheduled-orders-table
          [data]="data()"
          [loading]="loading()"
          [site]="currentSiteData()"
          [showCheckboxes]="true"
          [showActions]="true"
          [virtualScrolling]="false"
          [bulkLoading]="bulkOperationLoading()"
          [optimizedLayout]="true"
          [selection]="selectedItems()"
          [itemsCounts]="itemsCounts()"
          [accessToken]="getAccessToken()"
          [embeddedMode]="embeddedMode"
          (sortChanged)="onSortChanged($event)"
          (pageChanged)="onPageChanged($event)"
          (selectionChanged)="onSelectionChanged($event)"
          (rowAction)="onRowAction($event)"
          (bulkAction)="onBulkAction($event)"
          (navigateToCycle)="onNavigateToCycle($event)"
        />
      </div>
    </div>
  </div>

  <!-- Initial Loading Skeleton (only for first page load/refresh) -->
  @if (initialLoading()) {
    <app-list-page-skeleton
      [sidebarCollapsed]="sidebarCollapsed()"
      filterPreset="scheduledOrders"
      tablePreset="scheduledOrders"
    />
  }

  <!-- Empty State (when no site selected) -->
  <div *ngIf="!currentSiteId()" class="empty-state-container">
    <div
      class="flex flex-column align-items-center justify-content-center h-20rem gap-4"
    >
      <i class="pi pi-exclamation-circle text-6xl text-400"></i>
      <h2 class="text-xl font-medium text-600 m-0">No Site Selected</h2>
      <p class="text-center text-500 max-w-30rem">
        Please select a site from the navigation to view scheduled orders.
      </p>
    </div>
  </div>
</div>

<!-- Toast Messages for embedded/web component mode only -->
@if (embeddedMode) {
  <p-toast
    position="top-right"
    [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }"
  />
}

<!-- Confirmation Dialog -->
<p-confirmDialog
  [style]="{ width: '450px' }"
  [baseZIndex]="10000"
  rejectButtonStyleClass="p-button-text"
/>
